import React, { createRef, useState } from 'react';
import { Col, Row, Form, Space, Button, Input, message, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { createAssets, uploadFile } from '../Api/ApiCalls';
import AfterSubmit from './AfterSubmit';

const RequestAssetsForm = () => {
  const formRef = createRef();
  const [show, setShow] = useState(false);
  const [fileList, setFileList] = useState();
  const [number, setNumber] = useState(false);

  const { success } = message;

  const customRequest = ({ file, onSuccess }) => {
    const formData = new FormData();
    formData.append('files', file);
    setFileList(formData);
    onSuccess();
  };

  const onFinish = async (values) => {
    const randomNumber = Math.floor(1000 + Math.random() * 9000);
    values.Serial = values.Serial.replace(/[\t\n\s]+/g, '');
    values.orderNumber = `#${randomNumber}`;
    formRef.current?.resetFields();
    const image = await uploadFile(fileList);
    if (image) {
      values.Upload = image;
      const data = { data: values };
      const response = await createAssets(data);
      success('تم الاضافة بنجاح');
      if (response) {
        setNumber(randomNumber);
        setShow(true);
      }
    }
  };

  return (
    <>
      <Form
        hidden={!!show}
        name='basic'
        style={{ margin: '100px' }}
        ref={formRef}
        layout={'vertical'}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        autoComplete='off'
      >
        <Space direction='vertical' size='middle' style={{ display: 'flex' }}>
          <Row gutter={16}>
            <Col className='gutter-row' span={24} md={{ span: 12 }}>
              <Form.Item
                label=' الاسم الثلاثي'
                name='EmployeeName'
                rules={[{ required: true, message: 'Serial is Required!' }]}
              >
                <Input
                  style={{ marginBottom: '10px' }}
                  placeholder='ادخل البيانات'
                />
              </Form.Item>
            </Col>
            <Col className='gutter-row' span={24} md={{ span: 12 }}>
              <Form.Item
                label='الرقم الوظيفي'
                name='EmployeeId'
                rules={[{ required: true, message: 'Serial is Required!' }]}
              >
                <Input
                  style={{ marginBottom: '10px' }}
                  placeholder='ادخل البيانات'
                />
              </Form.Item>
            </Col>
            <Col className='gutter-row' span={24} md={{ span: 12 }}>
              <Form.Item
                label='البريد الالكتروني'
                name='email'
                rules={[{ required: true, message: 'email is Required!' }]}
              >
                <Input
                  type='email'
                  style={{ marginBottom: '10px' }}
                  placeholder='ادخل البيانات'
                />
              </Form.Item>
            </Col>
            <Col className='gutter-row' span={24} md={{ span: 12 }}>
              <Form.Item
                label='النقال'
                name='Mobile'
                rules={[{ required: true, message: 'Serial is Required!' }]}
              >
                <Input
                  type='number'
                  style={{ marginBottom: '10px' }}
                  placeholder='ادخل البيانات'
                />
              </Form.Item>
            </Col>
            <Col className='gutter-row' span={24} md={{ span: 12 }}>
              <Form.Item
                label='رقم العهدة'
                name='Serial'
                rules={[{ required: true, message: 'Serial is Required!' }]}
              >
                <Input
                  style={{ marginBottom: '10px' }}
                  placeholder='ادخل البيانات'
                />
              </Form.Item>
            </Col>
            <Col className='gutter-row' span={24} md={{ span: 12 }}>
              <Form.Item
                label='اسم العهدة'
                name='ItemName'
                rules={[{ required: true, message: 'Item is Required!' }]}
              >
                <Input
                  style={{ marginBottom: '10px' }}
                  placeholder='ادخل البيانات'
                />
              </Form.Item>
            </Col>
            <Col className='gutter-row' span={24} md={{ span: 12 }}>
              <Form.Item
                label='المواصفات'
                name='Specs'
                rules={[
                  { required: true, message: 'Specifications is Required!' },
                ]}
              >
                <Input
                  style={{ marginBottom: '10px' }}
                  placeholder='ادخل البيانات'
                />
              </Form.Item>
            </Col>
            <Col className='gutter-row' span={24} md={{ span: 12 }}>
              <Form.Item
                label='نظام التشغيل'
                name='os'
                rules={[{ required: true, message: 'OS is Required!' }]}
              >
                <Input
                  style={{ marginBottom: '10px' }}
                  placeholder='ادخل البيانات'
                />
              </Form.Item>
            </Col>
            <Col className='gutter-row' span={24} md={{ span: 12 }}>
              <Form.Item
                label='المبنى'
                name='Building'
                rules={[{ required: true, message: 'Building is Required!' }]}
              >
                <Input
                  style={{ marginBottom: '10px' }}
                  placeholder='ادخل البيانات'
                />
              </Form.Item>
            </Col>
            <Col className='gutter-row' span={24} md={{ span: 12 }}>
              <Form.Item
                label='الدور'
                name='Floor'
                rules={[{ required: true, message: 'Floor is Required!' }]}
              >
                <Input
                  style={{ marginBottom: '10px' }}
                  placeholder='ادخل البيانات'
                />
              </Form.Item>
            </Col>
            <Col className='gutter-row' span={24} md={{ span: 12 }}>
              <Form.Item
                label='المكتب'
                name='Office'
                rules={[{ required: true, message: 'Office is Required!' }]}
              >
                <Input
                  style={{ marginBottom: '10px' }}
                  placeholder='ادخل البيانات'
                />
              </Form.Item>
            </Col>
          </Row>
          <div style={{ textAlign: 'center' }}>
            <Form.Item name={'Upload'} style={{ textAlign: 'center' }}>
              <p>تحميل صورة الطلب الورقي</p>
              <Upload
                multiple={false}
                customRequest={customRequest}
                listType='picture'
              >
                <Button size='large' icon={<UploadOutlined />}>
                  Upload
                </Button>
              </Upload>
            </Form.Item>
          </div>
          <div style={{ textAlign: 'center' }}>
            <Button
              style={{ borderRadius: '5px', width: '150px' }}
              type='primary'
              htmlType='=submit'
              size={'large'}
            >
              طلب
            </Button>
          </div>
        </Space>
      </Form>
      {show && <AfterSubmit number={number} />}
    </>
  );
};

export default RequestAssetsForm;
